<template>
  <v-container>
    <v-row justify="center" class="my-12">
    <h1>Sorry! This page is not available on the server.</h1>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "NotFound",
  methods: {
    bookMarks () {
      return []
    }
  }
}
</script>

<style scoped>

</style>